import { useCallback, useState } from "react";
import { ACTIONS, EventData, STATUS } from "react-joyride";

export default function useTour(tourKey: string) {
  const [run, setRun] = useState(false);

  const onEvent = useCallback((data: EventData) => {
    if (
      data.status === STATUS.FINISHED ||
      data.status === STATUS.SKIPPED ||
      data.action === ACTIONS.CLOSE
    ) {
      setRun(false);
    }
  }, []);

  const replay = useCallback(() => {
    setRun(true);
  }, []);

  return { run, onEvent, replay };
}
